import $ from 'jquery';
import tippy from 'tippy.js';

jQuery(function($){

    if( $('#nc-checkout-form').length == 0 )
        return false;

    //place order
    $('span.nc-place-order').on('click', function(){
        $('button#place_order').trigger('click');
    });

    // display installment
    $('#deposit_field label').on('click', function(){
        let val = $(this).attr('for');
        let ele = $('.kbc-payment-guide');
        ele.children().hide();

        if( val == 'deposit_10' )
        {
            ele.find('.installment').fadeIn(300);
            return;
        }

        ele.find('.balance').fadeIn(300);
    });

    // tippy tooltip
    tippy('.installment-bar .tooltip-popup', {
        content: 'Loading...',
        onShow(instance) {
            let cont = `
            <div class="text-dark-grey p-2 border-radius radius-5" style="background-color:`+instance.reference.dataset.color+`">
                <p class="mb-0">Deadline</p>
                <p class="mb-1">Pay: `+instance.reference.dataset.amount+`</p>
                <p class="mb-0 fw-bold">Due on: `+instance.reference.dataset.due+`</p>
            </div>`;
            instance.setContent(cont);
        },
        allowHTML: true
    });

});